/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateScanResponse
 */
export interface ValidateScanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateScanResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateScanResponse
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateScanResponse
     */
    milestoneComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateScanResponse
     */
    questComplete?: boolean;
}

/**
 * Check if a given object implements the ValidateScanResponse interface.
 */
export function instanceOfValidateScanResponse(value: object): value is ValidateScanResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ValidateScanResponseFromJSON(json: any): ValidateScanResponse {
    return ValidateScanResponseFromJSONTyped(json, false);
}

export function ValidateScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateScanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'milestoneComplete': json['milestoneComplete'] == null ? undefined : json['milestoneComplete'],
        'questComplete': json['questComplete'] == null ? undefined : json['questComplete'],
    };
}

export function ValidateScanResponseToJSON(json: any): ValidateScanResponse {
    return ValidateScanResponseToJSONTyped(json, false);
}

export function ValidateScanResponseToJSONTyped(value?: ValidateScanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'milestoneComplete': value['milestoneComplete'],
        'questComplete': value['questComplete'],
    };
}

